import type { ReactNode } from 'react';
import { cn } from './cn';

export interface FieldProps {
  label?: ReactNode;
  htmlFor?: string;
  required?: boolean;
  /** Error message — shown in danger color, takes precedence over hint. */
  error?: ReactNode;
  /** Helper text shown below the control. */
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Label + control + hint/error wrapper (replaces antd Form.Item chrome). */
export function Field({ label, htmlFor, required, error, hint, children, className }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label != null && (
        <label htmlFor={htmlFor} className="text-[13px] font-medium text-content">
          {label}
          {required && <span className="text-danger-500"> *</span>}
        </label>
      )}
      {children}
      {error != null ? (
        <span className="text-xs text-danger-500">{error}</span>
      ) : hint != null ? (
        <span className="text-xs text-muted">{hint}</span>
      ) : null}
    </div>
  );
}
